import FetchService from './base.fetch';

const FeedbackService = {};

const apisConfig = {
    add: {
        domain: FetchService.domainconfig.mblock,
        method: 'post',
        url: 'mblock/feedback'
    }
};

FetchService.configToRequestAction.call(FeedbackService, apisConfig, FetchService);

export default FeedbackService;